<template>
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card">
                    <div>
                        <div></div>
                        <div class="login-main">
                            <form class="theme-form" @submit.prevent="verifyOTP">
                                <h4 class="text-center">Verify OTP</h4>
                                <p class="text-center">Enter the OTP sent to your email</p>
                                <div class="form-group">
                                    <label class="col-form-label">Email Address</label>
                                    <input v-model="email" class="form-control" type="email" readonly>
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">OTP</label>
                                    <input v-model="otp" class="form-control" type="text" 
                                        placeholder="Enter OTP" required maxlength="6">
                                </div>
                                <div class="form-group mb-0">
                                    <div class="text-end mt-3">
                                        <button class="btn btn-primary btn-block w-100" type="submit"
                                            :disabled="isSubmitting">
                                            {{ isSubmitting ? 'Verifying...' : 'Verify OTP' }}
                                        </button>
                                    </div>
                                </div>
                                <p class="mt-4 mb-0 text-center">
                                    <router-link class="ms-2" to="/auth/forgot-password">
                                        Resend OTP
                                    </router-link>
                                </p>
                                <p class="mt-2 mb-0 text-center">
                                    <router-link class="ms-2" to="/auth/login">
                                        Back to Login
                                    </router-link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_URL;
const toaster = createToaster({});
const router = useRouter();
const route = useRoute();

const email = ref<string>("");
const otp = ref<string>("");
const isSubmitting = ref<boolean>(false);

onMounted(() => {
    // Get email from query parameters
    if (route.query.email) {
        email.value = route.query.email as string;
    } else {
        // Redirect to forgot password page if no email is provided
        router.push('/auth/forgot-password');
    }
});

async function verifyOTP() {
    if (!otp.value) {
        toaster.show("Please enter the OTP", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    isSubmitting.value = true;
    try {
        const response = await axios.post(`${baseUrl}api/user/verify-reset-otp`, {
            email: email.value,
            otp: otp.value
        });

        toaster.show("OTP verified successfully", {
            theme: 'outline',
            position: 'top-right',
            icon: 'check',
            type: 'success',
            duration: 2000
        });

        // Store the reset token and redirect to reset password page
        const resetToken = response.data.resetToken;
        router.push({
            name: 'resetPassword',
            query: { 
                email: email.value,
                token: resetToken
            }
        });
    } catch (error: any) {
        console.error('Error verifying OTP:', error);
        toaster.show(error.response?.data?.message || "Invalid or expired OTP. Please try again.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    } finally {
        isSubmitting.value = false;
    }
}
</script> 